import { useEffect } from "react";
import { useMitt } from "@/context/shared/eventBus";
export var useSetPageData = function (data) {
    var mitt = useMitt();
    useEffect(function () { return mitt.emit("pageData", data); }, [mitt, data]);
};
